module.exports = function () {
    return {
        restrict: 'E',
        transclude: true,
        scope: {},
        template: require('./partner-smallformat.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/shop/partner/partner-smallformat.directive.js